module.exports = __webpack_public_path__ + "img/logo_wide_sa.6ed337cf.svg";